import { BusinessTypeAction } from '../actions/action.creators';
import { BusinessTypeState } from '../state/state';
import { BusinessTypeActionType as actions } from '../actions/action';
import { StateStatus } from '../../../../shared/infrastructure/store/utils/state_status';
// import BusinessTypeState from '../state/state.interface';

const businessType = (state = new BusinessTypeState({}), action: BusinessTypeAction) => {
    switch (action.type) {
        case actions.GETTING_BUSINESS_TYPE:
            return state.copyWith({
                status: StateStatus.loading, 
            });
        case actions.GETTING_BUSINESS_TYPE_SUCCESS:
            return state.copyWith({
                status: StateStatus.success, 
                liveBusinessType: action.payload,
            });
        case actions.GETTING_BUSINESS_TYPE_FAILURE:
            return state.copyWith({
                status: StateStatus.failure,
                liveBusinessType: null, 
                errorMessage: action.payload
            });
        default:
            return state;
    }
};

export default businessType;
